<template>
  <!-- Modal Component -->
  <b-modal v-model="showDuplicatedModal" size="lg" centered id="modalDuplicated" ref="modalDuplicated"  title="Selecciona un nou ticket a assignar">
    <b-form-select
      class="mb-1 mr-sm-1 mb-sm-0" size="sm"
      v-model="newTicketAssigned"
      :options="tickets_select">
      <template slot="first">
        <option :value="null" selected disabled>-- Selecciona el nou ticket a assignar --</option>
      </template>
    </b-form-select>
    <div slot="modal-footer" class="w-100">
      <b-btn class="float-right" variant="primary" @click="$bvModal.hide('modalDuplicated')">
        <font-awesome-icon :icon="['fas', 'check']"/>
        Escollir
      </b-btn>
    </div>
  </b-modal>
</template>

<script>

export default {
  props: {
    showDuplicatedModal: {
      required: true,
      Type: Boolean
    },
    originTicket: {
      required: true,
      Type: Object
    }
  },
  data () {
    return {
      newTicketAssigned: null,
      tickets_select: []
    }
  },
  watch: {
    // Transmitimos un evento personalizado y le pasamos el valor que haya elegido al padre
    newTicketAssigned: function (newVal) {
      this.$emit('updateNewTicketAssigned', newVal)
    }
  },
  computed: {
    groups_tickets () {
      return this.$store.state.manager.manager_groups_tickets
    },
    groups_history_tickets () {
      return this.$store.state.manager.manager_groups_history_tickets
    },
    user () {
      return this.$store.getters.getUser
    }
  },
  created() {
    // En aquest select mostrarem tots els tiquets de la categoria del manager que no estiguin tancats, rebutjats o esperant a ser tancats
    this.$store.dispatch('fetchManagerGroupsTickets', this.user.id).then(() => {
      this.groups_tickets = this.groups_tickets.filter(
        element => !['Descartada', 'Duplicada'].includes(element.estat.nom) && element.id !== this.originTicket
      )
      // Formatem els tiquets per mostrar-los al select
      this.tickets_select = this.groups_tickets.map(element => {
        let text = element.detalls.length > 110 ? `${element.detalls.substring(0, 110 - 3)}...` : element.detalls;
        return {
          text: `${element['id']} - ${text}`,
          value: element['id']
        };
      });
    });

    // DESHABILITAT PER NO MOSTRAR TOT L'HISTÒRIC DE TICKETS
    // this.$store.dispatch('fetchManagerGroupsHistoryTickets', this.user.id).then(() => {
    //   this.groups_history_tickets = this.groups_history_tickets.filter(
    //     element => !['Descartada', 'Duplicada'].includes(element.estat.nom) && element.id !== this.originTicket
    //   )
    //   // Ordenem els tickets per ID
    //   this.groups_history_tickets.sort((a, b) => b.id - a.id)
    //   // Formategem els tickets per mostrar-los al select
    //   this.tickets_select = this.groups_history_tickets.map(element => ({
    //     text: `${element['id']} - ${element.detalls.substring(0, (110 - 3)) + '...'}`,
    //     value: element['id']
    //   }))
    // })
  }
}
</script>

<style scoped>
</style>
